<script setup lang="ts">
/**
 * Card d'état "indisponible / complet / saison terminée" (fond ambré).
 */
defineProps<{
  icon: string;
  title: string;
  message: string;
}>();
</script>

<template>
  <div class="rounded-3xl overflow-hidden bg-[#FFF3C4] dark:bg-[#3D3520] p-8">
    <div class="flex flex-col items-center justify-center text-center py-4">
      <UIcon :name="icon" class="size-12 text-amber-600 dark:text-amber-400 mb-4" />
      <h3 class="text-xl font-bold text-[#1E1E1E] dark:text-white mb-2">
        {{ title }}
      </h3>
      <p class="text-sm text-[#5C5030] dark:text-gray-400 max-w-xs">
        {{ message }}
      </p>
    </div>
  </div>
</template>
